/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, timer } from 'rxjs';
import { retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { StateService } from '../services/state.service';
import { environment } from 'src/environments';

@Injectable()
export class MainInterceptor implements HttpInterceptor {
  private language = 'en';
  private office?: string;
  private userId?: string;
  constructor(
    private readonly router: Router,
    private readonly auth: AuthService,
    private readonly stateService: StateService
  ) {
    this.stateService.stateChanged.subscribe((state) => {
      this.language = state.get('language');
      this.office = state.get('officeId');
      this.userId = state.get('userId');
    });
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (this.userId) {
      const modifiedReq = request.clone({
        setHeaders: {
          'X-PestControl-Language': this.language || 'en',
          'X-PestControl-Office': this.office || '',
          'X-PestControl-UserId': this.userId || '',
          'X-PestControl-Version': environment.version || '',
        },
      });
      return next
        .handle(modifiedReq)
        .pipe(retry({ count: 2, delay: this.shouldRetry }));
    } else {
      const modifiedReq = request.clone({
        setHeaders: {
          'X-PestControl-Version': environment.version || '',
        },
      });
      return next
        .handle(modifiedReq)
        .pipe(retry({ count: 2, delay: this.shouldRetry }));
    }
  }

  shouldRetry(error: HttpErrorResponse) {
    if (error.status && error.status !== 403 && error.status !== 401) {
      console.log(error);

      return timer(500);
    }
    throw error;
  }
}
